import useSWR from 'swr';
import axiosInstance from 'apis/axiosInstance';
import { loadAuthToken } from 'utils/storage';
import { ROLE } from 'utils/constants';

interface IUserAllAdminParams {
  adminRole: string;
  limit: number;
  page: number;
  sort: 'asc' | 'desc';
  sortBy: string;
}

const useAllAdmin = ({
  adminRole,
  limit,
  page,
  sort,
  sortBy,
}: IUserAllAdminParams) => {
  const params = {
    limit: limit.toString(),
    page: page.toString(),
    sort,
    sortBy,
  };

  const query = new URLSearchParams(params).toString();

  const url =
    adminRole === ROLE.GROUP_ADMIN
      ? `/clinic-users/group-admin?${query}`
      : `/clinic-users/global-admin?${query}`;

  const { data, error, mutate } = useSWR(url, async (url) => {
    const response = await axiosInstance.get(url, {
      headers: {
        Authorization: `JWT ${loadAuthToken()!.accessToken}`,
      },
    });
    return response.data;
  });

  return { data, error, isLoading: !data && !error, mutate };
};

export default useAllAdmin;
